// test771
(771 && 0);
